import React from 'react';
import { connect } from 'react-redux';

import * as selectors from '../store/selectors';

import submitActions from '../actions/submit-design';

import uiActions from '../actions/ui';
import Button from './Button';
import './SubmitForm.css';

class SubmitForm extends React.Component {
  handleSubmit = e => {
    if (!this.form.checkValidity()) {
      return;
    }
    e.preventDefault();
    this.props.submitDesign({
      designId: this.props.selectedDesign.id,
      email: this.container.querySelector('input[name=email]').value,
      firstName: this.container.querySelector('input[name=firstName]').value,
      lastName: this.container.querySelector('input[name=lastName]').value,
      phone: this.container.querySelector('input[name=phone]').value,
      month: this.container.querySelector('input[name=month]').value,
      day: this.container.querySelector('input[name=day]').value,
      year: this.container.querySelector('input[name=year]').value,
      mainText: this.container.querySelector('input[name=mainText]').value
    });
    this.props.toggleThanksPage();
  };
  render() {
    const url =
      this.props.selectedDesign.attributes.preview_url ||
      'https://app.getpaddee.com/images/placeholder.png';
    return (
      <div>
        <div className="submit-form-overlay" />
        <div
          className="submit-form-container"
          ref={node => {
            this.container = node;
          }}
        >
          <div
            className="image-container"
            style={{ backgroundImage: 'url(' + url + ')' }}
          />
          <form
            className="client-form"
            ref={node => {
              this.form = node;
            }}
          >
            <h3>Your basic info:</h3>
            <div>
              <input placeholder="First Name" name="firstName" required />
              <input placeholder="Last Name" name="lastName" required />
              <input
                placeholder="Email Address"
                name="email"
                type="email"
                required
              />
              <input placeholder="Phone Number" name="phone" required />
              <input
                placeholder="MM"
                style={{ width: '60px' }}
                name="month"
                required
              />
              <input
                placeholder="DD"
                style={{ width: '60px' }}
                name="day"
                required
              />
              <input
                placeholder="YYYY"
                style={{ width: '60px' }}
                name="year"
                required
              />
              - Specify Event Date
            </div>
            <h3>Design info:</h3>
            <div>
              <input
                placeholder="Main Design Text"
                style={{ width: '98%' }}
                name="mainText"
                required
              />
            </div>
            <Button onClick={this.handleSubmit}>Submit</Button>
            <button onClick={this.props.onCancel} className="cancel-button">
              Cancel
            </button>
          </form>
        </div>
      </div>
    );
  }
}

export default connect(
  state => ({
    selectedDesign: selectors.getDesign(state, state.selectedDesignId)
  }),
  {
    toggleThanksPage: uiActions.toggleThanksPage,
    submitDesign: submitActions.submitDesign
  }
)(SubmitForm);



// WEBPACK FOOTER //
// ./src/components/SubmitForm.js